var BaseView = require('../../../../ui/tool-menu/components/helper/view');
var contentTemplate = require('./helper.hbs');
var videoId = 'vbTSmlfiYiA';

module.exports = BaseView.extend({
  events: _.extend({}, BaseView.prototype.events, {
    'click a.video': function () {
      this.openVideoContent(videoId, {width: 600});
    },

    'click .go-premium': 'displaySubscriptionModal'
  }),

  displaySubscriptionModal: function () {
    INKIVE.Helpers.displaySubscriptionModal('tool.versions.helper.description');
  },

  initialize: function () {
    BaseView.prototype.initialize.call(this);
    $('button[data-action=versions]').one('click', _.bind(this.render, this));
  },

  render: function () {
    this.data.title = 'tool.versions.helper.title';
    this.data.content = contentTemplate();
    this.$el.html(this.template(this.data));
  }
});
